import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Circular progress gauge for the onboarding journey.
 *
 * Drawn on a fixed 100×100 viewBox and scaled by `size`, so the same component serves the
 * page hero and the smaller popup recap without recomputing any geometry.
 */
@Component({
  selector: 'app-journey-progress-ring',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './journey-progress-ring.component.html',
})
export class JourneyProgressRingComponent {
  percent = input.required<number>();
  /** Rendered diameter, in pixels. */
  size = input(96);
  strokeWidth = input(9);

  readonly radius = computed(() => 50 - this.strokeWidth() / 2);
  readonly circumference = computed(() => 2 * Math.PI * this.radius());

  private readonly clampedPercent = computed(() =>
    Math.min(100, Math.max(0, this.percent())),
  );

  readonly dashOffset = computed(
    () => this.circumference() * (1 - this.clampedPercent() / 100),
  );

  /** Keeps the number legible whatever the ring size. */
  readonly labelSize = computed(() => Math.round(this.size() / 3.8));
}
